import { useCallback } from "react";
import get from "lodash/get";
import { createContext, useContext, useEffect, useRef } from "react";
export var AppContext = createContext({
    updateConfig: function (prop, value) { },
    presentation: {},
    config: {}
});
export var useConfig = function (prop, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var currentContext = useAppContext();
    var updateConfig = currentContext.updateConfig;
    var updater = useCallback(function (value) { return updateConfig(prop, value); }, [updateConfig, prop]);
    return [get(currentContext, "config." + prop, defaultValue), updater];
};
export var usePresentationComponent = function (component) {
    var currentContext = useAppContext();
    var comp = [].concat(component).map(function (componentType) { return get(currentContext, "presentation." + componentType, null); }).filter(Boolean)[0] || null;
    var ref = useRef(comp);
    useEffect(function () {
        ref.current = comp;
    }, [comp]);
    return ref.current;
};
export var useAppContext = function () {
    return useContext(AppContext);
};
